import request from '../../api/request';
const pptStore = {
    namespaced: true,
    state: {
        templateList: [], // 模版列表
        historyList: [], // 历史列表
    },
    getters: {},
    mutations: {
        // 存储模版
        async setTemplate(state, playload) {
            var _a;
            try {
                const res = await request.post('/app-api/lt/ai/ppt/getCoverList', {
                    title: (playload === null || playload === void 0 ? void 0 : playload.title) || '',
                    sessionId: (playload === null || playload === void 0 ? void 0 : playload.id) || '',
                    count: 9,
                    color: (playload === null || playload === void 0 ? void 0 : playload.color) || ''
                });
                state.templateList = Array.isArray((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.covers) && res.data.covers || [];
            }
            catch (error) {
            }
        },
        // 获取历史列表
        setHistory(state, playload) {
            request.post('/app-api/lt/ai/ppt/getPptSessionList', {}).then((res) => {
                state.historyList = Array.isArray(res === null || res === void 0 ? void 0 : res.data) && res.data || [];
            }).catch((err) => {
            });
        }
    },
    actions: {},
    modules: {}
};
export default pptStore;
